import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Constants } from "@constants";
import { AuthDTO, IAuthDTO } from "@DTOS";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Nilable } from "@shared/utils";

@Injectable({
    providedIn: "root"
})
export class AuthServiceBackend {
    constructor(protected http: HttpClient) {}

    public login(authDTO: AuthDTO): Observable<Nilable<AuthDTO>> {
        return this.http.post<IAuthDTO>(
            `${Constants.apiURL}/api-token-auth`, authDTO.toJSON()
        ).pipe(
            map(json => new AuthDTO(json))
        );
    }
}
